import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toggleModalDiagramDelete, diagramDelete } from '../../../redux/main/main.actions';
import { selectIsModalDiagramDeleteEnabled, selectModalDiagramDeleteData } from '../../../redux/main/main.selectors';

import { trackEvent } from '../../../lib/analytics';

import Modal from '../Modal/Modal';
import './ModalDiagramDelete.scss';

export const ModalDiagramDelete = () => {
    const dispatch = useDispatch();

    const isOpen = useSelector(selectIsModalDiagramDeleteEnabled);
    const modalData = useSelector(selectModalDiagramDeleteData);

    const [value, setValue] = useState(modalData?.diagram?.title || '');

    useEffect(() => {
        if (!modalData?.diagram?.title) return;

        if (value !== modalData?.diagram?.title) {
            setValue(modalData?.diagram?.title || '');
        }
        return () => { };
    }, [modalData]);

    const handleSave = () => {
        trackEvent('app_modal_diagram_delete_submit', {
            page: 'app',
            type: 'modals',
        });
        dispatch(diagramDelete(modalData?.diagram?.id));
        dispatch(toggleModalDiagramDelete(null));
    };

    const handleCancel = () => {
        dispatch(toggleModalDiagramDelete(null));
    };

    return (
        <Modal
            isOpen={isOpen}
            modalClass={`modal-diagram-delete`}
            // modalClass={`modal-diagram-clone ${page}`}
            onCancel={handleCancel}
        >
            <div className="modal-content-header">{`Permanently delete diagram`}</div>
            <div className="modal-content-body">
                {/* <div className='description-text'>{`This will permanently delete ${value}. You won’t be able to restore it.`}</div> */}
                <div className='description-text'>{`This will permanently delete `}<span className='text-title-bold'>{value}</span>. You won’t be able to restore it.</div>
                <div className='buttons-wrap'>
                    <button className='button-second' onClick={() => handleCancel()}>Cancel</button>
                    <button onClick={() => handleSave()}>Delete</button>
                </div>
            </div>
        </Modal>
    );
};

export default ModalDiagramDelete;
